import { gql } from '@apollo/client';
import { useApi } from 'lib';

const dumpLocalStorage = () => {
  let store = []
  for (let i = 0, l = localStorage.length; i < l; i++) {
    let key: any = localStorage.key(i);
    store.push({ key: key, value: localStorage.getItem(key) });
  }
  return JSON.stringify(store);
}

const useLogger = () => {
  const api = useApi();

  return {
    error: async (data: any, err: Error | undefined = undefined) => {
      if (
        (err && process.env.REACT_APP_ENV === 'production')
        || process.env.REACT_APP_ENV === 'production'
      ) {
        console.log('here');
        const result = await api.post('/dev/logger' + (err ? '/error' : ''), {
          ...data,
          url: window.location.href,
          storage: dumpLocalStorage(),
          navigator: JSON.stringify((window.navigator as any).userAgentData),
          error: err ? (err.message ? err.message + ': ' + err.stack : '') : ''
        })

        return result;
      }
    }
  }
}

const tracker = async (client: any, resource: string, guid: string) => {
  const trackResource = gql`
    mutation trackResource(
      $resource: String!
      $guid: ID!
    ) {
      trackResource(
        resource: $resource
        guid: $guid
      ) {
        success
        code
        message
      }
    }
  `;

  await client.mutate({
    mutation: trackResource,
    variables: { resource, guid }
  });
}

export {
  useLogger,
  tracker
};
